/**
 * Created by Ning Jiang on 11/17/2016.
 */
///<reference path="../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomEase.d.ts"/>
///<reference path="../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomBounce.d.ts"/>
///<reference path="../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomWiggle.d.ts"/>


require("../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomEase.js");
require("../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomBounce.js");
require("../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomWiggle.js");

import ("pixi.js");
import * as PIXI from "pixi.js";
window.PIXI = PIXI;

import {NolimitLauncher} from "@nolimitcity/slot-launcher/bin/NolimitLauncher";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {NolimitPromotionPlugin} from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import {WarriorGraveyardGameModuleConfig} from "./game/WarriorGraveyardGameModuleConfig";
import {WarriorGraveyard} from "./game/WarriorGraveyard";
import {WGIntroConfig} from "./game/intro/WGIntroConfig";
import {NolimitGameIntroPlugin} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/NolimitGameIntroPlugin";
import {NolimitSlotAudio} from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";

declare global {
    interface Window {
        PIXI: any;
        NolimitLauncher: NolimitLauncher;
    }
}
import {WarriorGraveyardPromoPanelConfig} from "./game/WarriorGraveyardPromoPanelConfig";

window.NolimitLauncher = NolimitLauncher.instance;
NolimitLauncher.instance.launch([
    new WarriorGraveyard(WarriorGraveyardGameModuleConfig.instance),
    new SlotKeypad(),
    new NolimitPromotionPlugin(new WarriorGraveyardPromoPanelConfig()),
    new NolimitGameIntroPlugin(new WGIntroConfig()),
    new NolimitSlotAudio()]);
